import client from "./client";

/* 상품 */


export const getInquiries = (params) => client.get(`/inquiry/`, { params });

export const editInquiry = (params) => client.put(`/inquiry/${params?.id}/`, params );

export const deleteInquiry = (params) => client.delete(`/inquiry/${params?.id}/`, params );
